import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { PermissionCheck } from "@/components";
import { PermissionRoles } from "@/enum";

import { useGetApiHealthOverviewQuery } from "../../redux/apiHealth/apiHealth.api";
import { HostCard } from "./components/HostCard";

export const ApiHealth: FunctionComponent = () => {
	const { t } = useTranslation();
	const { data, isLoading, isError } = useGetApiHealthOverviewQuery();

	return (
		<PermissionCheck requiredPermissions={[PermissionRoles.GLOBAL_ADMIN]}>
			<div className="w-full">
				<div className="mb-6">
					<h3 className="mb-3">{t("apiHealth.title")}</h3>
					<p className="pr-5 text-xs text-gray-700 lg:max-w-[650px]">{t("apiHealth.subtitle")}</p>
				</div>

				{data && (
					<div className="mb-6 flex flex-wrap items-center gap-x-6 gap-y-1 text-xs text-gray-600">
						<span>{data.probesEnabled ? t("apiHealth.probesOn") : t("apiHealth.probesOff")}</span>
						<span>
							{t("apiHealth.cost", {
								calls: data.probeCost.callsPerMonth.toLocaleString(),
								cost: data.probeCost.costPerMonth.toFixed(2),
							})}
						</span>
						{data.probeCost.unpricedEndpoints.length > 0 && (
							<span className="text-amber-700">
								{t("apiHealth.costUnpriced", {
									count: data.probeCost.unpricedEndpoints.length,
								})}
							</span>
						)}
					</div>
				)}

				{isError && <p className="text-xs text-red-700">{t("apiHealth.error")}</p>}
				{isLoading && <p className="text-xs text-gray-500">…</p>}

				{data?.hosts.map((host) => (
					<HostCard key={host.host} host={host} />
				))}
			</div>
		</PermissionCheck>
	);
};
